import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeAuthorisedContact } from '../services/authorisedContacts';
import { agreementKeys } from './agreementKeys';

/** Never optimistic: a revocation is a legal fact, and showing it before the
 *  server has it would be a lie the user might act on. */
export function useRevokeAuthorisedContactMutation(id: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (contactId: string) => revokeAuthorisedContact(id, contactId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: agreementKeys.authorisedContacts(id) });
            void queryClient.invalidateQueries({ queryKey: agreementKeys.history(id) });
        },
    });
}
